import {
  Component,
  forwardRef,
  Inject,
  Input
}                           from '@angular/core';
import {
  BlockUI,
  NgBlockUI
}                           from 'ng-block-ui';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { AdminDashboardService } from './admin-dashboard.service';
import { ConfirmService }        from '../messages/confirm/confirm.service';
import { MessagesService }       from '../messages/messages.service';
import { WsImportTableModel }    from './typings/admin-dashboard.ws-import-table';

@Component({
  template: require('./admin-dashboard.ws-to-ws-import.component.html'),
  selector   : 'wor-admin-dashboard-ws-to-ws-import'
})
export class WsToWsImportComponent {
  @BlockUI('wsToWsImport') block : NgBlockUI;

  @Input() company  : any;

  sourceCompany : string;
  tables        : Array<WsImportTableModel> = this.adminDashboardService.getImportTables();
  targetCompany : any = {
    company_name: '',
    id          : ''
  };

  selectedTables    = { tables: [] };

  constructor (
    public  activeModal           : NgbActiveModal,
    @Inject(forwardRef(() => AdminDashboardService))
    private adminDashboardService : AdminDashboardService,
    private confirmService        : ConfirmService,
    private messagesService       : MessagesService,
    private translateService      : TranslateService
  ) {}

  confirm () : void {
    const selectedTables = this.getSelectedTables();
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.CONFIRM_WS_TO_WS_IMPORT', {
        tables     : selectedTables.join(", "),
        companyName: this.targetCompany.company_name
    }))
    .then(() => this.block.start())
    .then(() => this.adminDashboardService.wsToWsTransfer( this.company, this.targetCompany, selectedTables ))
    .then(() => this.activeModal.close())
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  getSelectedTables () : Array<string> {
    return this.tables
      .filter(table => table.status)
      .map(table => table.name);
  }

  handleModelChange ( company : any ) : void {
    this.targetCompany = Object.assign({}, company);
  }

  handleSwitchToggle ( table : WsImportTableModel ) : void {
    if ( table.status ) {
      this.selectParentTables(table);

      if ( table.name === 'products' && this.tables.find(t => t.name === 'vendors').status === false ) {
        this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.CONFIRM_VENDORS_IMPORT_FOR_PRODUCTS'))
        .then(() => this.tables.find(t => t.name === 'vendors').status = true)
        .catch(error => this.messagesService.error(error));
      }
    }
    else {
      this.unselectChildTables(table);
    }
  }

  isFormInvalid( form : any ) : void {
    return form.invalid || this.tables.filter(t => t.status).length < 1;
  }

  selectParentTables ( table : WsImportTableModel ) : void {
    if ( !table.parent ) {
      return;
    }

    const parent = this.tables.find(t => t.name === table.parent);

    if ( parent && !parent.status ) {
      parent.status = true;

      this.selectParentTables(parent);
    }
  }

  search = ( typed : string ) => {
    return this.adminDashboardService.search(typed);
  }

  unselectChildTables ( table : WsImportTableModel ) : void {
    if ( !table.child ) {
      return;
    }

    const child = this.tables.find(t => t.name === table.child);

    if ( child && child.status ) {
      child.status = false;

      this.unselectChildTables(child);
    }
  }
}